export default {
  'privacyPolicy.title': 'Privacy Policy'
};
